export default "__VITE_ASSET__CP6sv6MS__"